import React from 'react';

export default props => (
  <svg width={14} height={8} {...props}>
    <path
      d="M1 1l6.008 6L13 1"
      stroke="#999"
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
